export const SHERBERT_URL = 'https://api.sherbert.cimpress.io';
export const SHERBERT_BASE_URL = 'https://api.sherbert.cimpress.io/v2/assets';
export const UMS_BASE_URL = 'https://uploads.design.vpsvc.com/api/v1/uploads';
export const UPLOADS_BASE_URL = 'https://uploads.documents.cimpress.io/v1/uploads';
// TODO: make a common base url inplace of different base url for v2 & v3
export const SHERBERT_V3_BASE_URL = 'https://api.sherbert.cimpress.io/v3/assets';
export const DEFAULT_SHERBERT_BASE_URL = 'https://api.sherbert.cimpress.io';
//# sourceMappingURL=constants.js.map